import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { URLSearchParamsKeys } from '../../constants/constants'

type SearchParamKey = keyof typeof URLSearchParamsKeys

export type SearchParamsState = {
    [K in SearchParamKey]?: string
}

const initialState: SearchParamsState = {}

const searchParamsSlice = createSlice({
    name: 'searchParams',
    initialState,
    reducers: {
        setSearchParam: (
            state,
            action: PayloadAction<{
                key: SearchParamKey
                value: string | undefined
            }>,
        ) => {
            const { key, value } = action.payload
            if (value === undefined) {
                delete state[key]
            } else {
                state[key] = value
            }
        },
        resetSearchParams: () => initialState,
        setMultipleSearchParams: (
            state,
            action: PayloadAction<Partial<SearchParamsState>>,
        ) => {
            Object.assign(state, action.payload)
        },
    },
})

export const { setSearchParam, resetSearchParams, setMultipleSearchParams } =
    searchParamsSlice.actions

export default searchParamsSlice.reducer
